module.exports = __webpack_public_path__ + "static/media/treasure-test.e64cbef4.png";